import { isSet } from '../utils/isSet';

class QuantityButton {
    constructor (domNode) {
        this.quantityButton = domNode;
        this.quantityContainer = this.quantityButton.parentElement;
        this.quantityInput = this.quantityContainer.querySelector('.qty');
        this.quantityType = this.quantityButton.dataset.quantityType;
        
        this.quantityInputMax = parseInt(this.quantityInput.getAttribute('max')) ?? null;
        this.quantityInputMin = parseInt(this.quantityInput.getAttribute('min')) ?? null;
        this.quantityInputStep = parseInt(this.quantityInput.getAttribute('step')) ?? null;

        if(!isSet(this.quantityInput)) return;

        this.incrementInputValue = this.incrementInputValue.bind(this);
        this.quantityButton.addEventListener(
            'click', 
            this.incrementInputValue
        );
    }

    incrementInputValue(){
        this.quantityInputVal = parseInt(this.quantityInput.value);

        

        if(this.quantityType === 'plus'){
            if ( isSet(this.quantityInputMax) && ( this.quantityInputMax <= this.quantityInputVal ) ) {
                this.quantityInput.value = this.quantityInputMax;
                this.quantityInput.setAttribute('value', this.quantityInputMax);
            } else{
                this.quantityInput.value = this.quantityInputVal + this.quantityInputStep;
                this.quantityInput.setAttribute('value', this.quantityInputVal + this.quantityInputStep);
            }

            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if(this.quantityType === 'minus'){
            if(this.quantityInputVal === 0) return;

            if ( isSet(this.quantityInputMin) && ( this.quantityInputMin >= this.quantityInputVal ) ) {
                this.quantityInput.value = this.quantityInputMin;
                this.quantityInput.setAttribute('value', this.quantityInputMin);
            } else{
                this.quantityInput.value = this.quantityInputVal - this.quantityInputStep;
                this.quantityInput.setAttribute('value', this.quantityInputVal - this.quantityInputStep);
            }

            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}
  
exports.QuantityButton = QuantityButton